module.exports = __webpack_public_path__ + "img/chevron-right.05bd8d3d.svg";